import React from 'react'
import PropTypes from 'prop-types'
import {TabsNavigation as PepsicoDsTabsNavigation} from '@pepsico-ds/ui'

/**
 * TabsNavigation component that renders a PepsicoDsTabsNavigation with properties from props.
 *
 * @param {Object} props - The properties object.
 * @param {Array} props.tabList - The list of tabs to display.
 * @param {boolean} [props.isDarkTab=true] - Optional boolean to indicate dark mode styling for the tabs.
 * @param {number} props.activeTabIndex - The index of the currently active tab.
 * @param {Function} props.handleSetActiveTab - The function to handle tab change events.
 * @param {ReactNode} props.children - The tabs to display as children.

 * @returns {JSX.Element} The rendered TabsNavigation component.
 */

const TabsNavigation = ({handleSetActiveTab, activeTabIndex, className, type, children}) => {
  return (
    <PepsicoDsTabsNavigation
      onUpdate={handleSetActiveTab}
      selectedIndex={activeTabIndex}
      className={className}
      type={type}
    >
      {children}
    </PepsicoDsTabsNavigation>
  )
}

TabsNavigation.propTypes = {
  handleSetActiveTab: PropTypes.func,
  activeTabIndex: PropTypes.number,
  className: PropTypes.string,
  type: PropTypes.oneOf(['line', 'shadow', 'border']),
  children: PropTypes.node,
}

export default TabsNavigation
